/** @format */

import {styled} from '@mui/material/styles';
import {Button} from '@mui/material';

export type BlueButtonSize = 'medium' | 'large';

export interface RootProps {
  active?: boolean;
  size?: BlueButtonSize;
}

export const Root = styled(Button, {
  shouldForwardProp: prop => prop !== 'active' && prop !== 'size',
})<RootProps>(({theme, active, size}) => ({
  height: size === 'medium' ? '32px' : '48px',
  borderRadius: '8px',
  background: active ? theme.palette.figma_primary?.light : theme.palette.figma_primary?.dark,
  gap: theme.spacing(2),
  padding: theme.spacing(0, 4),
  transition: '0.2s',

  color: theme.palette.semantic_dark?.primary.on,
  fontSize: size === 'medium' ? '14px' : '16px',
  fontWeight: 400,
  lineHeight: size === 'medium' ? '16px' : '20px',

  '.MuiSvgIcon-root': {
    transition: '0.2s',
    fontSize: size === 'medium' ? '16px' : '20px',
    color: theme.palette.semantic_dark?.primary.on,
  },

  '&:hover': {
    background: active ? theme.palette.figma_primary?.light : theme.palette.figma_primary?.main,
  },

  '&.Mui-disabled': {
    background: theme.palette.semantic_dark?.disabled.inverseDisabledLow,
    color: theme.palette.semantic_dark?.disabled.inverseDisabled,

    '.MuiSvgIcon-root': {
      color: theme.palette.semantic_dark?.disabled.inverseDisabled,
    },
  },
}));
